import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconConnect = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={20}
    fill="none"
    viewBox="0 0 26 20"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.8}
      d="M23.86 1.64c1.054 1.055 1.6 2.383 1.6 3.75.04 1.485-.468 2.93-1.6 4.063l-5.196 5.195c-1.094 1.094-2.5 1.602-3.906 1.602-1.406 0-2.813-.508-3.906-1.602-1.797-1.796-2.07-4.53-.899-6.64.352-.313.781-.508 1.25-.508s.938.195 1.25.547c.117.117.235.273.313.43l-.196.117a3.112 3.112 0 0 0-.86 2.148c0 .82.352 1.563.9 2.149a3.112 3.112 0 0 0 4.296 0l5.196-5.196a3.112 3.112 0 0 0 0-4.297c-.586-.546-1.329-.898-2.149-.898-.82 0-1.562.352-2.148.898L16.32 4.883a2.734 2.734 0 0 0-.312-.39 7.885 7.885 0 0 0-1.64-1.173l1.679-1.68A5.507 5.507 0 0 1 19.953 0c1.406 0 2.813.547 3.906 1.64ZM9.64 15.157c.079.117.196.274.313.39.508.47 1.055.86 1.64 1.173l-1.679 1.68C8.82 19.491 7.414 20 6.008 20c-1.406 0-2.813-.508-3.906-1.602C1.008 17.344.5 15.898.5 14.492c0-1.406.508-2.812 1.602-3.906L7.297 5.39a5.507 5.507 0 0 1 3.906-1.641c1.406 0 2.813.547 3.906 1.64 1.797 1.798 2.07 4.532.899 6.641a1.842 1.842 0 0 1-1.25.469c-.469 0-.938-.156-1.25-.508a1.733 1.733 0 0 1-.313-.43l.157-.117a3.112 3.112 0 0 0 0-4.297c-.586-.546-1.29-.898-2.149-.898-.82 0-1.562.313-2.148.898l-5.196 5.196a3.112 3.112 0 0 0 0 4.297 3.112 3.112 0 0 0 4.297 0l1.485-1.485Z"
    />
  </svg>
));
export default SvgIconConnect;
